import { DashboardAnalyticsResponse } from "../../types/dashboard/dashboard.model";
import { mapDashboardAnalyticsDto } from "../../types/dashboard/dashboard.mapper";
import {
  GetPropertiesFilters,
  PropertyRequest,
} from "../../types/listings/listing.model";
import { api } from "../axios";
import { queryObjects } from "../listing/listingApi";

const DASHBOARD_ANALYTICS_URL = import.meta.env.VITE_DASHBOARD_ANALYTICS_URL;
const GET_DASHBOARD_PROPERTIES_URL = import.meta.env
  .VITE_DASHBOARD_PROPERTIES_URL;
const UPDATE_PROPERTY_URL = import.meta.env.VITE_DASHBOARD_UPDATE_PROPERTY_URL;
const DELETE_PROPERTY_URL = import.meta.env.VITE_DASHBOARD_DELETE_PROPERTY_URL;

export const getMyDashboardAnalytics =
  async (): Promise<DashboardAnalyticsResponse> => {
    try {
      const res = await api.get(DASHBOARD_ANALYTICS_URL);
      return mapDashboardAnalyticsDto(res.data);
    } catch (error) {
      console.log("getMyDashboardAnalytics in dashboardApi error: ", error);
      throw error;
    }
  };

/** One row per own listing — all of them, not a page (my-report). */
export interface MyListingReportRow {
  id: number;
  title?: string;
  image?: string | null;
  status?: string | null;
  moderation_status?: string | null;
  views: number;
  favorites: number;
}

/**
 * «Просмотры по объявлениям» must add up to «Всего просмотров»: the totals
 * are a SUM over every listing, so the breakdown comes from my-report (every
 * listing) rather than the current page of my-properties.
 */
export const getMyListingsReport = async (): Promise<MyListingReportRow[]> => {
  const url = String(DASHBOARD_ANALYTICS_URL || "").replace(/my-dashboard\/?$/, "my-report");
  const res = await api.get(url);
  const rows: any[] = res.data?.properties ?? [];
  return rows.map((r) => ({
    id: Number(r.id),
    title: r.title,
    image: r.image ?? null,
    status: r.status ?? null,
    moderation_status: r.moderation_status ?? null,
    views: Number(r.views) || 0,
    favorites: Number(r.favorites) || 0,
  }));
};

export const getMydashboardProperties = async (
  offset: number,
  page: number,
) => {
  try {
    const res = await api.get(
      GET_DASHBOARD_PROPERTIES_URL + queryObjects({ offset, page }),
    );
    return res.data;
  } catch (error) {
    console.log("getMydashboardPropertiesApi in dashboardApi error: ", error);
    // throw error;
  }
};

export const updateProperty = async (id: number, data: PropertyRequest) => {
  try {
    console.log(data)
    const res = await api.patch(`${UPDATE_PROPERTY_URL}${id}`, data);
    return res.data;
  } catch (error) {
    console.log("updateProperty in dashboardApi error: ", error);
    // throw error;
  }
};

export const deleteProperty = async (id: number) => {
  try {
    const res = await api.delete(`${DELETE_PROPERTY_URL}${id}`);
    return res.data;
  } catch (error) {
    console.log("deleteProperty in dashboardApi error: ", error);
    // Без throw ошибка сервера показывалась как «Удалено», а объявление
    // возвращалось при следующей загрузке списка.
    throw error;
  }
};

export type CloseOutcome = "sold" | "changed_mind" | "no_response" | "other";
export type SoldVia = "turaq" | "other_site" | "offline" | "realtor" | "other";

export interface CloseListingPayload {
  outcome: CloseOutcome;
  soldVia?: SoldVia;
  comment?: string;
}

/**
 * Снять объявление с ответом «почему» (POST /property/:id/close).
 * «Продано» оставляет объявление в профиле со статусом sold, остальное
 * удаляет. Пока бэкенд без эндпоинта (404) — прежний путь: sold через
 * PATCH status, иначе DELETE.
 */
export const closeProperty = async (
  id: number,
  payload: CloseListingPayload,
): Promise<{ deleted: boolean }> => {
  try {
    const res = await api.post(`${UPDATE_PROPERTY_URL}${id}/close`, payload);
    return { deleted: Boolean(res.data?.deleted) };
  } catch (error) {
    const status = (error as { response?: { status?: number } }).response
      ?.status;
    if (status !== 404) throw error;
    if (payload.outcome === "sold") {
      await api.patch(`${UPDATE_PROPERTY_URL}${id}`, { status: "sold" });
      return { deleted: false };
    }
    await api.delete(`${DELETE_PROPERTY_URL}${id}`);
    return { deleted: true };
  }
};
